// VINEY menu (part S3, 2026-10-23; homepage spec 7, Christmas spec 7c and 7f, Site Patterns 9.14): the script
// state of snippets/vn-menu.liquid. Linked twice (the desktop row and the phone sheet); a module runs once.
// - Desktop: places an open panel under its word, inside the window (16 px from each edge); the last panel is
//   anchored right. Escape closes it and puts focus back on its word. The photo cards warm on the first hover.
// - Phone sheet: one pill open at a time (focus and the phone's Back are vn-motion.js's, section 11).
// - The seat and the Christmas foot line: shown and hidden at their start and end, the countdown each minute
//   while the sheet is open (whole minutes left, floored, at least 1, on the minute counted back from the end: the
//   window's count, sections/vn-window.liquid, so the two never disagree), the gift line switched at the last order
//   time; no reload. One timer per page: these times go on the engine's timer (window.vnEvH, snippets/vn-event.liquid)
//   when the engine is on the page; on an ordinary day (no engine) the same runner, shared with Verslunin's script.
// - The open-now line at the foot, from the same hours as Verslunin (snippets/vn-hours.liquid); the algorithm is
//   Verslunin's (sections/vn-shop.liquid), so the two lines always agree.
// - The external mark (9.14) on every link to another site the server did not mark: target _blank, rel noopener,
//   the mark and the hidden text, for links rich text and apps put on the page.
// A Horizon section refresh (morph) brings new markup: everything above is worked out again from what the
// server sent (data-vn-keep keeps the states set here while it does).

const D = 864e5;
const now = () => Date.now();
const sec = (el, a) => +(el.getAttribute(a) || 0) * 1000;

/* ---- desktop panels ---- */
// the placing is the desktop row's inline first-hover script's (blocks/_header-menu.liquid, window.vnMnPlace: P3b),
// so a panel opened before this script ran sits in the same place
const place = (a) => { if (window.vnMnPlace) window.vnMnPlace(a); };
let warmed = false;
const warm = (root) => {
  if (warmed) return;
  warmed = true;
  root.querySelectorAll('img[data-vn-lazy]').forEach((i) => { i.loading = 'eager'; });
};
const navs = new WeakSet();
const wireNav = (hm) => {
  if (navs.has(hm)) return;
  navs.add(hm);
  new MutationObserver((list) => {
    for (const m of list) if (m.target.classList && m.target.classList.contains('vn-mnl')) place(m.target);
  }).observe(hm, { subtree: true, attributes: true, attributeFilter: ['aria-expanded'] });
  hm.addEventListener('pointerenter', () => warm(hm), { once: true });
  hm.addEventListener('focusin', () => warm(hm), { once: true });
};
// Escape closes an open panel (opened by hover too, so focus may be anywhere) and puts focus on its word. The inline
// first-hover script (blocks/_header-menu.liquid) handles Escape until this module loads (window.vnMnEsc); it is taken
// off here, whichever of this and header-menu.js came first, so one handler acts at a time (polish P2 r2). Before
// header-menu.js binds, the panel is the inline opener's: close it and mark its word (data-vn-esc) so the resting
// pointer does not reopen it until it leaves (P3b r1); once bound, the menu's own deactivate.
window.vnMnEscOn = true;
if (window.vnMnEsc) { document.removeEventListener('keydown', window.vnMnEsc); window.vnMnEsc = null; }
document.addEventListener('keydown', (e) => {
  if (e.key !== 'Escape') return;
  const a = document.querySelector('header-menu .vn-mnl[aria-expanded="true"]');
  const hm = a && a.closest('header-menu');
  if (!hm) return;
  if (typeof hm.deactivate !== 'function') {
    a.setAttribute('aria-expanded', 'false');
    a.parentElement.setAttribute('data-vn-esc', '');
    a.focus();
    return;
  }
  a.focus();
  hm.deactivate({ target: a.parentElement, relatedTarget: null, type: 'keydown' });
});
window.addEventListener('resize', () => {
  document.querySelectorAll('.vn-mnl[aria-expanded="true"]').forEach(place);
});

/* ---- phone sheet ---- */
const sheets = new WeakSet();
const wireSheet = (det) => {
  if (sheets.has(det)) return;
  sheets.add(det);
  det.addEventListener('click', (e) => {
    const b = e.target instanceof Element && e.target.closest('button.vn-pl__s');
    if (!b) return;
    const open = b.getAttribute('aria-expanded') !== 'true';
    det.querySelectorAll('button.vn-pl__s[aria-expanded="true"]').forEach((o) => { if (o !== b) pill(o, false); });
    pill(b, open);
  });
  let was = det.classList.contains('menu-open');
  new MutationObserver(() => {
    const is = det.classList.contains('menu-open');
    if (is === was) return;
    was = is;
    // (focus to the X on open and back to the menu button on close: vn-motion.js section 11, the overlays)
    if (is) refresh();
  }).observe(det, { attributes: true, attributeFilter: ['class'] });
};
const pill = (b, open) => {
  const k = document.getElementById(b.getAttribute('aria-controls'));
  b.setAttribute('aria-expanded', String(open));
  b.parentElement.classList.toggle('is-op', open);
  if (k) k.hidden = !open;
};

/* ---- the seat, the Christmas line, the open-now line ---- */
const fill = (t, h, m) => t.replace('{h}', h).replace('{m}', m);
let T = null;
const strings = (f) => {
  if (T) return T;
  try { T = JSON.parse(f.getAttribute('data-vn-t')); } catch (e) { T = null; }
  return T;
};
const setText = (el, s) => { if (el.textContent !== s) el.textContent = s; };
const seat = (el, n) => {
  const s = sec(el, 'data-vn-s');
  const e = sec(el, 'data-vn-e');
  const on = n >= s && n < e;
  if (el.hidden === on) el.hidden = !on;
  const c = el.querySelector('.vn-seatp__c');
  if (!c) return;
  if (el.hasAttribute('data-vn-cd')) {
    const f = document.querySelector('.vn-mf');
    const t = f && strings(f);
    if (!t) return;
    const m = Math.max(1, Math.floor((e - n) / 6e4));
    // in the last hour minutes only (Ívar, 2026-10-28), as the window's "Endar eftir M mín."
    setText(c, m < 60 && t.leftm ? fill(t.leftm, 0, m) : fill(t.left, Math.floor(m / 60), m % 60));
  } else if (el.hasAttribute('data-vn-lo')) {
    setText(c, n < sec(el, 'data-vn-lo') ? el.getAttribute('data-vn-a') : el.getAttribute('data-vn-b'));
  }
};
const xmas = (el, n) => {
  const off = n >= sec(el, 'data-vn-e');
  if (el.hidden !== off) el.hidden = off;
  setText(el, n < sec(el, 'data-vn-lo') ? el.getAttribute('data-vn-a') : el.getAttribute('data-vn-b'));
};
// the open-now line: Verslunin's rules (sections/vn-shop.liquid) on the same hours
const openLine = (f) => {
  let C;
  try { C = JSON.parse(f.getAttribute('data-vn-hours')); } catch (e) { return; }
  const t = strings(f);
  if (!t || !C) return;
  const key = (d) => new Date(d).toISOString().slice(0, 10);
  const hrs = (d) => { const x = C.x[key(d)]; if (x != null) return x; const w = new Date(d).getUTCDay(); return w ? (w > 5 ? C.s : C.w) : 0; };
  // minutes of the day (an opnun time can be off the hour: 21.5 is 21:30, snippets/vn-hours.liquid); it reads "21:30"
  const M = (x) => Math.round(x * 60);
  const F = (x) => { const m = M(x) % 60; return Math.floor(M(x) / 60) + (m ? `:${m < 10 ? '0' : ''}${m}` : ''); };
  const n = new Date(); const h = n.getUTCHours() * 60 + n.getUTCMinutes(); const d0 = Date.UTC(n.getUTCFullYear(), n.getUTCMonth(), n.getUTCDate());
  const a = hrs(d0); const open = !!a && h >= M(a[0]) && h < M(a[1]);
  let line = t.shut;
  if (open) line = (C.x[key(d0)] && a[1] > 18 ? t.eve : t.now).replace('{h}', F(a[1]));
  else if (a && h < M(a[0])) line = t.at.replace('{h}', F(a[0]));
  // "opnar á mánudag" is the standing weekend's; an exception from today to then gives the day and date (spec 6); the
  // next opening is searched for over the hours' whole span (C.n, snippets/vn-hours.liquid), past it "Lokað"
  else for (let i = 1, xs = C.x[key(d0)] != null; i <= C.n; i++) {
    const b = hrs(d0 + i * D); if (!b) { xs = xs || C.x[key(d0 + i * D)] != null; continue; } const w = new Date(d0 + i * D);
    line = (w.getUTCDay() == 1 && i < 3 && !xs ? (a ? t.mon : t.mtd) : i == 1 ? t.tm : t.on.replace('{d}', t.wdl[w.getUTCDay()] + ' ' + w.getUTCDate() + '.' + (w.getUTCMonth() + 1) + '.')).replace('{h}', F(b[0]));
    break;
  }
  const o = f.querySelector('.vn-mf__o');
  if (!o) return;
  setText(o, `${line} `);
  if (o.classList.contains('is-open') !== open) o.classList.toggle('is-open', open);
  f.classList.toggle('is-open', open);
  if (o.hidden) o.hidden = false;
};

const paint = (n) => {
  T = null;
  document.querySelectorAll('[data-vn-seat]').forEach((el) => seat(el, n));
  document.querySelectorAll('.vn-mx').forEach((el) => xmas(el, n));
  document.querySelectorAll('.vn-mf').forEach(openLine);
};
// the next time (ms) anything here changes: a seat's or a foot line's start, end or last order; while the sheet is
// open also the next minute (the open-now line) and each countdown's own minute, counted back from its end as the
// window's is
const nextAt = (n) => {
  let next = Infinity;
  document.querySelectorAll('[data-vn-seat], .vn-mx').forEach((el) => {
    for (const a of ['data-vn-s', 'data-vn-e', 'data-vn-lo']) { const v = sec(el, a); if (v > n && v < next) next = v; }
  });
  if (document.querySelector('details.menu-open .vn-md__in')) {
    next = Math.min(next, n + 6e4 - (n % 6e4));
    document.querySelectorAll('[data-vn-seat][data-vn-cd]').forEach((el) => {
      const r = sec(el, 'data-vn-e') - n;
      if (r > 0) next = Math.min(next, n + (r % 6e4 || 6e4));
    });
  }
  return next;
};
// the engine calls this on each of its runs (t in seconds) and wakes again at the time it returns
const hook = (t) => { const n = t * 1000; paint(n); const x = nextAt(n); return x < Infinity ? x / 1000 : 0; };
// no engine (an ordinary day): the same one-timer runner, set up once for every hook on the page; Verslunin's script
// (sections/vn-shop.liquid) sets up the same if it runs first (Event run P5), so the page keeps one timer
const runner = () => {
  if (typeof window.vnEvRun === 'function') return;
  const H = window.vnEvH || (window.vnEvH = []);
  let z = 0;
  const run = () => {
    const t = Date.now() / 1e3;
    let m = Infinity;
    for (const u of H) { try { const x = +u(t); if (x > t && x < m) m = x; } catch (e) { /* one hook never stops the rest */ } }
    clearTimeout(z);
    if (m < Infinity) z = setTimeout(run, Math.min((m - t) * 1e3 + 50, 2147e6));
  };
  window.vnEvRun = run;
  window.addEventListener('pageshow', (e) => { if (e.persisted) run(); });
  document.addEventListener('visibilitychange', () => { if (!document.hidden) run(); });
};
let hooked = false;
const refresh = () => {
  runner();
  if (!hooked) { hooked = true; (window.vnEvH = window.vnEvH || []).push(hook); }
  window.vnEvRun();
};

/* ---- the external mark on every other external link (9.14) ----
   Worked out again whenever a link's href, target or rel changes or nodes go into or out of it (a morph can keep
   the anchor and change where it goes, or strip what this put in): a link to another site has the mark, its words,
   a new tab and noopener; a link inside the shop has none of them. Every write is skipped when it is already so,
   so the observer that sees these writes settles at once. When a link turns internal, only what this wrote is taken
   back, and an attribute is put back only while it still holds what this wrote: a value the server or a morph
   supplied since stays (verifier round 2, F3).
   9.14's exception (FU1, 2026-10-24): a link that is only an icon, with no visible words, shows no mark. It still
   gets the new tab, noopener and the hidden words; a mark already in it (put in by this or by a morph) goes. The
   test is the link's content, read again on every pass, so it holds after a morph or a change of href.
   FU1 fix r1 (verifier round 1, 2026-10-24): the pass also runs when what decides "only an icon" changes without a
   node going in or out (hidden on or off, the visually-hidden class on or off, text changed in place) and when the
   link's aria-label changes (a new label gets the new tab's words again). Words that were hidden and show keep the
   hidden words the icon had: only the mark is added, so the words are never read twice.
   FU1 fix r2 (F2): a class change is read as whole tokens (visually-hidden-mobile is not visually-hidden).
   FU2 (2026-10-24, the S3 follow-up): a link the server marked (its mark or its hidden words still in it, or its
   label ending in them), whose href alone then changes to the shop's, loses the new tab and the label's words as
   well (this wrote neither, so the rule above did not take them back). A morph that brings the server's internal
   markup takes the mark out with it, so a target the server gives such a link stays; a link still going to another
   site is never stripped. */
let hosts = null;
let tpl = null;
let hidText = '';
// what this wrote on each link: { attribute: [the value before, the value this wrote] }
const own = new WeakMap();
const isExt = (a) => {
  let u;
  try { u = new URL(a.href, location.href); } catch (e) { return false; }
  const h = u.hostname.toLowerCase();
  // the shop's own hosts and their subdomains (account.viney.is, the customer accounts) are not other sites
  return /^https?:$/.test(u.protocol) && !hosts.some((x) => h === x || h.endsWith('.' + x));
};
const setA = (a, n, v) => { if (v == null) { if (a.hasAttribute(n)) a.removeAttribute(n); } else if (a.getAttribute(n) !== v) a.setAttribute(n, v); };
// a write of this sweep's own: skipped when already so; otherwise kept with the value it replaced (the first one,
// while the attribute still holds this sweep's last write; the new one, when something else wrote in between)
const put = (a, n, v) => {
  const cur = a.getAttribute(n);
  if (cur === v) return;
  let o = own.get(a);
  if (!o) own.set(a, (o = {}));
  if (!o[n] || o[n][1] !== cur) o[n] = [cur, v]; else o[n][1] = v;
  setA(a, n, v);
};
const hidIn = (a) => [...a.querySelectorAll('.visually-hidden')].filter((s) => s.textContent.trim() === hidText);
// only an icon: a drawing (an svg other than the mark), no image, and no visible words (text inside the svg, the
// hidden words or anything hidden does not count)
const iconOnly = (a) => {
  if (!a.querySelector('svg:not(.vn-ext)') || a.querySelector('img, picture, video')) return false;
  const w = document.createTreeWalker(a, NodeFilter.SHOW_TEXT);
  for (let n = w.nextNode(); n; n = w.nextNode()) {
    if (!n.data.trim()) continue;
    const c = n.parentElement && n.parentElement.closest('svg, .visually-hidden, [hidden], template, script, style');
    if (!c || !a.contains(c)) return false;
  }
  return true;
};
// class and rel tokens split on ASCII whitespace only, as classList does (FU1 fix r3)
const WS = /[\t\n\f\r ]+/;
const extOne = (a) => {
  if (a.closest('[data-vn-noext]')) return;
  const mark = a.querySelector('svg.vn-ext');
  if (isExt(a)) {
    put(a, 'target', '_blank');
    const rel = (a.getAttribute('rel') || '').split(WS).filter(Boolean);
    if (!rel.includes('noopener')) put(a, 'rel', [...rel, 'noopener'].join(' '));
    if (!a.classList.contains('vn-xl')) a.classList.add('vn-xl');
    // a link named by aria-label does not read its content: the hidden text goes into the label as well
    const lab = a.getAttribute('aria-label');
    if (lab && hidText && !lab.includes(hidText)) put(a, 'aria-label', `${lab} ${hidText}`);
    if (iconOnly(a)) {
      a.querySelectorAll('svg.vn-ext').forEach((e) => e.remove());
      if (hidText && !hidIn(a).length && !(a.getAttribute('aria-label') || '').includes(hidText)) a.append(tpl.content.querySelector('.visually-hidden').cloneNode(true));
      return;
    }
    if (!mark) {
      const f = tpl.content.cloneNode(true);
      if (hidIn(a).length) f.querySelectorAll('.visually-hidden').forEach((e) => e.remove());
      a.append(f);
    } else if (hidText && !hidIn(a).length && !(lab || '').includes(hidText)) mark.before(tpl.content.querySelector('.visually-hidden').cloneNode(true));
    return;
  }
  const o = own.get(a);
  // still marked as going to another site: the mark, its hidden words, or a label ending in them
  const lab0 = a.getAttribute('aria-label') || '';
  const signed = !!mark || hidIn(a).length > 0 || (!!hidText && lab0.endsWith(hidText));
  if (!o && !signed) return;
  own.delete(a);
  // the mark, its words and the class say "another site": they go (a morph to an internal link brings none)
  a.querySelectorAll('svg.vn-ext').forEach((e) => e.remove());
  hidIn(a).forEach((e) => e.remove());
  if (a.classList.contains('vn-xl')) a.classList.remove('vn-xl');
  // the attributes this wrote go back to what they were, unless something else has written them since
  if (o) for (const n of Object.keys(o)) if (a.getAttribute(n) === o[n][1]) setA(a, n, o[n][0]);
  if (!signed) return;
  // the server's own "another site" attributes on a link whose href alone changed: the new tab, noopener and the
  // label's words go too
  if (a.getAttribute('target') === '_blank') a.removeAttribute('target');
  const rel = (a.getAttribute('rel') || '').split(WS).filter(Boolean);
  if (rel.includes('noopener')) setA(a, 'rel', rel.filter((x) => x !== 'noopener').join(' ') || null);
  const lab = a.getAttribute('aria-label');
  if (lab && hidText && lab.endsWith(hidText)) setA(a, 'aria-label', lab.slice(0, -hidText.length).trim() || null);
};
/* ---- the press on a one-line external link in running text (9.14: 97 %; verifier round 2, F4) ----
   Rich text keeps its links inline (vn-motion.css section 7), and an inline box takes no transform. For the press
   (pointer down until just after release) a link that sits on one line becomes an inline-block exactly its own
   content height: the same box on the same line, its underline where it was (vn-motion.css section 3). A link that
   wraps stays inline (as one box it could not wrap): it does not scale, and its arrow still moves. */
const RUN = '.rte, .text-block, .vn-pill__body, .vn-quiet';
const still = matchMedia('(prefers-reduced-motion: reduce)');
let pressA = null;
let pressOff = 0;
const unpress = () => {
  const a = pressA;
  pressA = null;
  if (!a) return;
  a.classList.remove('vn-xl--1');
  a.style.removeProperty('--vn-xh');
  if (!a.getAttribute('style')) a.removeAttribute('style');
};
const release = () => { clearTimeout(pressOff); pressOff = setTimeout(unpress, 200); };
document.addEventListener('pointerdown', (e) => {
  if (still.matches || e.button > 0) return;
  const a = e.target instanceof Element ? e.target.closest('a.vn-xl') : null;
  if (!a || !a.closest(RUN)) return;
  clearTimeout(pressOff);
  if (pressA === a) return;
  unpress();
  if (a.getClientRects().length !== 1 || getComputedStyle(a).display !== 'inline') return;
  a.style.setProperty('--vn-xh', `${a.offsetHeight}px`);
  a.classList.add('vn-xl--1');
  pressA = a;
}, true);
addEventListener('pointerup', release, true);
addEventListener('pointercancel', release, true);

const extIn = (root) => {
  if (!hosts) return;
  if (root.matches && root.matches('a[href]')) extOne(root);
  if (root.querySelectorAll) root.querySelectorAll('a[href^="http"], a[href^="//"]').forEach(extOne);
};
let pending = new Set();
let queued = false;
const flush = () => {
  queued = false;
  const list = pending; pending = new Set();
  list.forEach((nd) => { if (nd.isConnected) extIn(nd); });
};
const startExt = () => {
  const t = document.querySelector('template.vn-ext-t');
  if (!t || hosts) return;
  tpl = t;
  hosts = (t.getAttribute('data-hosts') || '').split(',').map((h) => h.trim().toLowerCase()).filter(Boolean);
  hosts.push(location.hostname.toLowerCase());
  const hid = t.content.querySelector('.visually-hidden');
  hidText = hid ? hid.textContent.trim() : '';
  extIn(document.body);
  new MutationObserver((list) => {
    for (const m of list) {
      if (m.type === 'childList') m.addedNodes.forEach((nd) => { if (nd.nodeType === 1) pending.add(nd); });
      // a class change counts only when it hides or shows words (the visually-hidden class going on or off, as a token)
      if (m.attributeName === 'class' && (m.oldValue || '').split(WS).includes('visually-hidden') === m.target.classList.contains('visually-hidden')) continue;
      // a changed destination or label, words shown or hidden, or something taken out of or put into a link: that link again
      const el = m.target.nodeType === 1 ? m.target : m.target.parentElement;
      const a = el && el.closest && el.closest('a[href]');
      if (a && (m.type !== 'childList' || m.removedNodes.length || m.addedNodes.length)) pending.add(a);
    }
    if (pending.size && !queued) { queued = true; requestAnimationFrame(flush); }
  }).observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeOldValue: true, attributeFilter: ['href', 'target', 'rel', 'aria-label', 'hidden', 'class'] });
};

/* ---- start, and again after a section refresh ---- */
let again = false;
const wire = () => {
  again = false;
  document.querySelectorAll('header-menu').forEach(wireNav);
  document.querySelectorAll('details.menu-drawer-container').forEach(wireSheet);
  startExt();
  refresh();
  document.querySelectorAll('.vn-mnl[aria-expanded="true"]').forEach(place);
};
const start = () => {
  wire();
  // a refresh replaces or rewrites the menu's markup: wire and work everything out again, once a frame
  const hdr = document.querySelector('header-component') || document.body;
  new MutationObserver((list) => {
    // the foot line at once, before the next paint: a refresh puts the server's empty line back (Event run P5 r1), and
    // the line writes only a changed, never empty text, so a shopper never sees the foot blank
    if (list.some((m) => (m.target.nodeType === 1 ? m.target : m.target.parentElement)?.closest?.('.vn-mf'))) document.querySelectorAll('.vn-mf').forEach(openLine);
    if (again) return;
    for (const m of list) {
      const el = m.target.nodeType === 1 ? m.target : m.target.parentElement;
      // any change, removals too (a refresh empties the lines this script writes); the writes here change nothing
      // the second time, so this settles
      if (el && el.closest && el.closest('.vn-md__in, .vn-ni, .vn-mp, header-drawer, header-menu')) { again = true; requestAnimationFrame(wire); return; }
    }
  }).observe(hdr, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['data-vn-s', 'data-vn-e', 'data-vn-lo', 'data-vn-hours', 'data-vn-t'] });
};
// P3b (2026-10-28): the desktop row loads this async (blocks/_header-menu.liquid), so it can run while the page is
// still loading. The row above it is parsed: its panels are placed from the first hover (header-menu.js may open
// one already). Everything else (the engine, the sheet, the rest of the page) waits for the whole document.
if (document.readyState === 'loading') {
  document.querySelectorAll('header-menu').forEach(wireNav);
  document.querySelectorAll('.vn-mnl[aria-expanded="true"]').forEach(place);
  document.addEventListener('DOMContentLoaded', start, { once: true });
} else start();
// (with the engine on the page, its own pageshow and visibilitychange runs call the hook)
window.addEventListener('pageshow', (e) => { if (e.persisted && !hooked) refresh(); });
document.addEventListener('visibilitychange', () => { if (!document.hidden && !hooked) refresh(); });
